module.exports = __webpack_public_path__ + "img/房间环境监测.98f08518.png";